import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HCMore from 'highcharts/highcharts-more';
HCMore(Highcharts);

const PackedBubbleChart = () => {
    const options = {
        chart: {
            type: 'packedbubble',
            height: '100%',
            plotBackgroundColor: null,
            backgroundColor: 'transparent',
            margin: 0,
        },
        title: {
            text: null,
        },
        navigation: {
            buttonOptions: {
                enabled: false,
            },
        },
        credits: {
            enabled: false,
        },
        yAxis: {
            startOnTick: true,
            showFirstLabel: false,
            showLastLabel: false,
            maxPadding: 0.2
        },
        tooltip: {
            useHTML: true,
            backgroundColor: '#000',
            style: {
                color: '#fff',
                fontSize: '12px',
                fontWeight: 500,
            },
            formatter: function() {
                return `<b>${this.key}</b>: ${this.y}<br>`;
            },
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            packedbubble: {
                pointPadding: 0,
                groupPadding: 0,
                borderWidth: 0,
                minSize: '30%',
                maxSize: '100%',
                // zMin: 0,
                // zMax: 1000,
                layoutAlgorithm: {
                    gravitationalConstant: 0.02,
                    splitSeries: false,
                    seriesInteraction: false,
                    dragBetweenSeries: false,
                    parentNodeLimit: true,
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        color: '#000',
                        textOutline: 'none',
                        fontSize: '12px',
                        fontWeight: 400,
                    },
                    formatter: function () {
                        return this.point.name.replace(/\s+/g, '<br>'); 
                    },
                },
                animation: {
                    duration: 0,
                },
                enableSimulation: false,
            },
        },
        colorAxis: {
            minColor: '#EDD8EB',
            maxColor: '#C76EBA'
        },
        series: [
            {
                name: 'Data',
                data: [
                    { name: 'Management', value: 280, },
                    { name: 'Case manager', value: 550, },
                    { name: 'Nociceptive Pain', value: 430, },
                    { name: 'Crap Gap', value: 910, },
                    { name: 'Regimen', value: 810,},
                    { name: 'Radiologically Isolated Syndrome (RIS)', value: 530, },
                    { name: 'Clinically Isolated Syndrome (CIS)', value: 190, },
                    { name: 'Neoadjuvant therapy', value: 870, },
                    { name: 'Imaging test', value: 280, },
                    { name: 'Targeted therapy', value: 550, },
                    { name: 'Oligoclonal Bands', value: 430, },
                ],
            },
        ],
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 300 // Work Before Width 1399px for column 4 if maxWidth is 300.
                },
                chartOptions: {
                    tooltip: {
                        style: {
                           fontSize: '10px',
                        },
                    },
                }
            }]
        }
    };

    return <HighchartsReact
                containerProps={{ style: { height: 'auto', width: '100%' } }} 
                highcharts={Highcharts} 
                options={options} 
            />;
};

export default PackedBubbleChart;
